import PageShell from '@/pages/shared/PageShell';
import { Link } from 'react-router-dom';

const FEATURES = [
  { icon: 'ri-brain-line', title: 'AIタスク分解', desc: '企画書やPDFからAIがタスクを自動分解。担当者、期限、依存関係を提案します。', path: '/features/ai-task-breakdown/' },
  { icon: 'ri-bar-chart-horizontal-line', title: 'AIガントチャート', desc: 'タスクの親子関係、依存関係、マイルストーン、予実比較を自動表示。', path: '/features/ai-gantt/' },
  { icon: 'ri-file-text-line', title: 'AI日報', desc: '自由な文章で報告するだけで、AIが進捗を解析しタスクを自動更新。', path: '/features/ai-daily-report/' },
  { icon: 'ri-folders-line', title: 'AIファイル管理', desc: '資料をアップロードすればAIが内容を読み取り、根拠付きで回答。', path: '/features/ai-file-management/' },
  { icon: 'ri-team-line', title: 'チーム機能', desc: 'プロジェクト別チャット、タスク別コメント、通知で情報を一元化。', path: '/features/team-collaboration/' },
  { icon: 'ri-translate-2', title: '多言語・多国祝日', desc: '日英タイ3言語対応。国別祝日を考慮したスケジュール管理。', path: '/features/multilingual/' },
];

export default function Features() {
  return (
    <PageShell
      title="機能一覧｜AIプロジェクト管理ツール ”おもいむすび”"
      description="”おもいむすび”の全機能をご紹介。AIタスク分解、AIガントチャート、AI日報、AIファイル管理、チーム機能、多言語対応。プロジェクト管理に必要な機能をAIで強化します。"
      keywords="プロジェクト管理 機能,AI タスク分解,AI ガントチャート,AI 日報,プロジェクト管理 ツール機能"
      canonical="https://omoimusubi.asia/features/"
      h1="資料を渡すだけで、AIがタスクを整理する"
      subtitle="”おもいむすび”は、プロジェクト管理に必要な6つの機能をAIで強化し、計画から進捗管理、情報共有までを一元化します。"
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 not-prose my-10">
        {FEATURES.map((f) => (
          <Link key={f.path} to={f.path} className="group bg-background-100 rounded-lg border border-background-200/70 p-6 hover:border-primary-300 transition-all cursor-pointer">
            <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center mb-4">
              <i className={`${f.icon} text-primary-600 text-xl`}></i>
            </div>
            <h2 className="text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">{f.title}</h2>
            <p className="text-sm text-foreground-600">{f.desc}</p>
          </Link>
        ))}
      </div>
    </PageShell>
  );
}